import api from '@/ts/api';
import tools from '@/ts/tools';
import { WebsocketStore } from '@/ts/ws';
import { useStorage } from '@vueuse/core';
import { defineStore } from 'pinia';


export const Support = defineStore('support', {
  state: () => ({         
    storeMessages: useStorage('stima_team_support_messages', []),    
    // storeLast: useStorage('stima_team_support_last', 0),
    storeGeneralChats: useStorage('stima_team_support_general_chats', []),
    storeAssetsChats: useStorage('stima_team_support_assets_chats', []),    
  }),
  
  getters: {
      messages: (state) => (uid, asset) =>{
        if (uid & asset) return state.storeMessages.filter(p => p.uid == uid && p.asset == asset)
        return state.storeMessages.filter(p => p.uid == uid)
      },      
      assetsMessages: (state) => (asset) =>{        
        return state.storeMessages.filter(p => p.asset == asset)
      },      
      chatlist: (state) => {
        let res = state.storeGeneralChats
        // let today = new Date()
        // state.storeGeneralChats.forEach(chat => {
        //   if (chat.created) {            
        //     let created = new Date(chat.created * 1000)
        //     let diff = Math.round( (today.getTime() - created.getTime()) / 1000 / 60)
        //     chat.online = diff < 5
        //     chat.diff = diff
        //     // console.log('chat diff', diff,'sec', chat)
        //     // console.log(chat.uid, 'today', today,'created', created)
        //   }          
        // });

        return res
      },    

      assetsChats: (state) => {
        let today = new Date()
        state.storeAssetsChats.forEach(chat => {
          if (chat.created) {            
            let created = new Date(chat.created * 1000)
            let diff = Math.round( (today.getTime() - created.getTime()) / 1000 / 60)
            chat.online = diff < 5
            chat.diff = diff            
          }          
        });

        return state.storeAssetsChats
      },      
  },
  actions: {
    
    async refreshSupport(id){
      let res = await api.send('support/chats/get',{id})
      // r.Set("user", user)
      // r.Set("assets", assets)
      // r.Set("messages", messages)
      if (res.error) return      
      this.list = res.resp
      return {}
    },

    async refreshGeneralChats(limit, offset){
      if (!limit) limit = 50
      let res = await api.send('admin/chats/list/support', {limit, offset})      
      if (res.error) return
      
      let items = res.resp
      if (!items) return
      if (!items.length) return
      // console.log("general chats", items)      
      this.storeGeneralChats = items
      // this.addsGeneralChats(items)      
    },
    
    async refreshAssetsChats(limit, offset){
      if (!limit) limit = 50
      let res = await api.send('support/assets/chats', {limit, offset})      
      if (res.error) return      
      let items = res.resp
      if (!items) return
      if (!items.length) return
      // console.log("general chats", items)      
      this.storeAssetsChats = items
      // this.addsGeneralChats(items)      
    },
    
    async refreshAssetsChat(asset, limit, offset){
      console.log('refresh asset chat', asset)
      if (!asset) return
      if (!limit) limit = 50
      let res = await api.send('support/assets/chat', {asset,limit,offset})      
      if (res.error) return      
      this.adds(res.resp)  
    },

     adds(messages){
      messages.forEach(message => {
        this.storeMessages.push(message)  
      });      
      this.sort()
    },


    add(message){
      console.log('push message', message)
      this.storeMessages.push(message)      
      this.sort()
      if (!message.asset) this.updateGeneralChat(message)
    },
    
    updateGeneralChat(message){
        this.storeGeneralChats.forEach(chat => {
          if (chat.asset) return
          if (chat.uid != message.uid) return
          chat.message = message.text
          chat.created = message.created
          chat.team = message.team
        });
    },
    
   
    
    addsGeneralChats(chats){
      chats.forEach(chat => {
        this.storeGeneralChats.push(chat)  
      });      
      this.sortGeneralChats()
    },
    
    sortGeneralChats(){
      var newlist = []
      var un = {}
      this.storeGeneralChats.forEach(p =>{
        if (un[p.uid]) return
        if (!p.uid) return        
        un[p.uid] = true
        newlist.push(p)
      })
      newlist.sort((a,b) => a.created < b.created);
      this.storeGeneralChats = newlist
    },
   
    sort(){
      var newlist = []
      var un = {}
      this.storeMessages.forEach(p =>{
        if (un[p.id]) return
        if (!p.id) return
        if (!p.uid) return
        un[p.id] = true
        newlist.push(p)
      })
      newlist.sort((a,b) => a.id < b.id);
      this.storeMessages = newlist
    },

    subscribe(){
      const websocket = WebsocketStore()
      let handle = this.add
      websocket.subscribe('support/message', function(res){
        let message = res.resp
        if (!message) return
        handle(message)
      })  
    },
  
    clear(){
      this.storeMessages = []      
    },

    async sendAsset(uid, asset, text, files, quote){
      
      let p = {uid, asset, text, quote} 

      p.files = await this.uploadingFiles(files)
      
      // try to send
      let res = await api.send('support/assets/send', p)      
      if (res.error) return res      
      // this.add(p)
      // if (!res.resp){
      //   console.error('chat/error',"empty result")
      //   return {id:'empty',code: 400}
      // }

    },
     
    // [1,2,3,4,5]
    read(messages){      
      api.send('support/read', {messages})
    },

    async uploadingFiles(files){
      if (!files) return
      
      let result = {}
      let list = files || []
      if (list.length == 0) return {}
      
      for (let x = 0; x < list.length; x++) {        
        const file = list[x];        
        let bytes = await tools.readFileAsBytes(file)
        if (!bytes) {
          console.log('cant read file', file)
          continue
        }
        let res = await api.upload.file(bytes, file.name, this.uid)
        if (res.error) {
          console.log('upload error', res)
          continue
        }
        result[file.name] = res.resp        
      }      
      return result || {}
    },


  },
})


/* 

type SupportChat struct {
    User    int    `json:"uid,omitempty"`
    Name    string `json:"name,omitempty"`
    Image   string `json:"image,omitempty"`
    Read    int64  `json:"read,omitempty"`
    Created int64  `json:"created,omitempty"`
    Message string `json:"message,omitempty"`
}
    
*/